/*
 * Javier Quevedo-Fernandez
 * Copyright Ranj Games. 2013
 */

/*
 * Class that holds information of a particular screen
 * @constructor
 * @param {DisplayObjectContainer} screen
 * @param {Bool} keepOnStage
 */
export default class ScreenInformation {
    constructor(screen, keepParentOnStage) {
        this.screen = screen;
        this.keepParentOnStage = keepParentOnStage;
    }
}